var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.containerInputClass},[(_vm.maxLength)?_c('div',{class:_vm.inputTitleClass},[_vm._v(_vm._s(_vm.letterLength))]):_vm._e(),_c('input',{attrs:{"type":"text","maxlength":_vm.maxLength},domProps:{"value":_vm.value},on:{"input":_vm.updateValue}})])
}
var staticRenderFns = []

export { render, staticRenderFns }